<!--
component: ListKyoaiAddress
author: Ken Nakamura
description: 狭あい道路住所検索結果リスト
-->
<template>
  <section>
    <v-data-table
      id="table"
      :headers="headers"
      :items="kenkaku"
      :fixed-header="false" height="calc(100vh - 20em)"
      mobile-breakpoint="0"
      disable-pagination hide-default-footer dense
      :single-select="true" item-key="daichoId"
    >
      <template v-slot:body="{ items }">
        <tbody>
          <tr v-for="(item, index) in items"
            @click="selectRow(item)"
            :id="item.id"
            :key="index"
            :class="{selected:item.active}"
            class="default"
          >
            <td>{{item.ukeNo}}</td>
            <td>{{item.chiban}}</td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </section>
</template>

<script>
import { dbglog } from '../common/utils'

export default {
  data: () => {
    return {
      headers: [
        {
          text: '協議番号',
          value: 'ukeNo'
        },
        {
          text: '地名地番',
          value: 'chiban'
        },
      ],
    }
  },
  props: {
  },
  mounted () {
    this.scrollToSelection();
  },
  computed: {
    kenkaku () {
      return this.$store.state.summaries;
    },
  },
  methods: {
    /**
     * 一覧でクリックされた行を選択
     * @param {GaiyoSummary} target 選択する概要データ
     */
    selectRow (target) {
      dbglog(`ListKyoaiAddress.selectRow(${target.daichoId})`);
      this.$store.commit('setGaiyoId', target.id);
      this.$store.commit('setUkeDay', target.ukeDay);
      this.$store.commit('setUkeNo', target.ukeNo);
      this.kenkaku.forEach((k) => {
        k.active = (k === target);
      });
    },
    /**
     * 選択されている物件がリスト中央に表示されるようにスクロールする
     */
    scrollToSelection () {
      if (this.$store.state.gaiyoId) {
        const tr = document.getElementById(this.$store.state.gaiyoId);
        //behaviorを指定すると建築PC（Edgeの古いバージョン？）で動かないかもしれない
        //tr.scrollIntoView({ behavior: 'smooth', block: 'center' });
        tr.scrollIntoView({ block: 'center' });
      }
    }
  },  
}
</script>
<style scoped src="@/styles/table-styles.css">
</style>